import { FactSheetState } from '../interface/FactSheetInterface'

export default function (state: FactSheetState = { employment_bullets: "", stayed_bullet: "" }, action) {

    switch (action.type) {
        case "DATA_PAGE1":
        case "SET_TEXT":
            
            return Object.assign({}, state, action.payload);


        case "FACT_SHEET_HOMESTATE_INFO":
            return {
                ...state,
                homestate_info: action.payload
            }

        case "RESET_EMPLOYMENT_BULLETS":
            var newState = Object.assign({}, state);
            newState["employment_bullets"]= "";

            return newState;
        default:
            return state;
    }
}
